import styled from "styled-components";

const MobileMenuStyled = styled.div`
  position: fixed;
  top: 70px;
  left: 0;
  width: 100%;
  height: calc(100vh - 70px);
  background-color: #1a1a1a;
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 24px;

  @media (min-width: 768px) {
    top: 80px;
    height: calc(100vh - 80px);
    padding: 32px;
  }

  @media (min-width: 1024px) {
    display: none;
  }

  &.open {
    transform: translateX(0);
  }

  .mobile-menu__nav {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 32px;
    flex: 1;
  }

  .mobile-menu__item {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    color: #ffffff;
    text-decoration: none;
    font-size: 1.25rem;
    font-weight: 500;
    transition: all 0.3s ease;
    border: 2px solid transparent;
    cursor: pointer;
    width: 100%;
    text-align: left;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      transform: translateX(8px);
      border-color: rgba(255, 255, 255, 0.2);
    }

    &:focus-visible {
      outline: 2px solid #4a7c59;
      outline-offset: 2px;
      background-color: rgba(255, 255, 255, 0.05);
    }

    &.active {
      background-color: #2d5016;
      border-color: #6b8e23;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }
  }

  .mobile-menu__icon {
    width: 24px;
    height: 24px;
    margin-right: 16px;
    flex-shrink: 0;
  }

  .mobile-menu__footer {
    margin-top: auto;
    padding-top: 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
`;

export default MobileMenuStyled;
